import axios from "axios";

const API_URL = "https://doclicapp.herokuapp.com/api/auth/";

class AuthService {
  login(username, password) {
    return axios
      .post(API_URL + "signin", {
        username,
        password,
      })
      .then((response) => {
        if (response.data) {
          sessionStorage.setItem("user", JSON.stringify(response.data));
        }
        return response.data;
      });
  }

  async logout() {
    await window.location.replace("/");
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("Type");
    sessionStorage.removeItem("analyse");
    sessionStorage.removeItem("DateRdv");
  }

  register(
    email,
    password,
    cin,
    firstName,
    lastName,
    tel,
    adresse,
    codePostal,
    city
  ) {
    return axios.post(API_URL + "signup", {
      email,
      password,
      cin,
      firstName,
      lastName,
      tel,
      adresse,
      codePostal,
      city,
    });
  }

  getCurrentUser() {
    return JSON.parse(sessionStorage.getItem("user"));
  }
}

export default new AuthService();
